import { TOP_LEVEL_TOT_TEST_IDS } from '@/top-level-tot/constants';
import { TranslateFunction } from 'deckard-ui/dist/utils/translator';
import debounce from 'lodash/debounce';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Input } from 'rsuite';

type Props = {
  searchQuery: string;
  onChange: React.Dispatch<React.SetStateAction<string>>;
  translate: TranslateFunction;
};

export function SearchInputField({
  searchQuery,
  onChange,
  translate,
}: Props): JSX.Element {
  const apnString = translate('APN', 'default', true);
  const placeholder = `Search for an address, ${apnString}, Taxes Paid or Payment Reference Number`;

  const [internalValue, setInternalValue] = useState<string>(searchQuery);

  const debouncedOnChange = useMemo(
    () => debounce((value: string) => onChange(value), 250),
    [onChange]
  );

  const onInputChange = useCallback(
    (value: string) => {
      setInternalValue(value);
      debouncedOnChange(value);
    },
    [debouncedOnChange, setInternalValue]
  );

  /**
   * Returning the cancel method, so that when the component is unmounted
   * then all residual debounced calls will be cleaned up.
   */
  useEffect(() => debouncedOnChange.cancel, [debouncedOnChange]);

  return (
    <Input
      data-testid={TOP_LEVEL_TOT_TEST_IDS.PAYMENT_PERIOD_SEARCH}
      placeholder={placeholder}
      value={internalValue}
      onChange={onInputChange}
    />
  );
}
